// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SmartGoals-module__font-s-10___apIa3 {
  font-size: 10px !important;
}

.SmartGoals-module__font-s-12___oQYFc {
  font-size: 12px !important;
}

.SmartGoals-module__font-s-13___gV4ah {
  font-size: 13px !important;
}

.SmartGoals-module__font-s-14___gHUbm {
  font-size: 14px !important;
}

.SmartGoals-module__font-s-15___qD8NW {
  font-size: 15px !important;
}

.SmartGoals-module__font-s-16___k4uhq {
  font-size: 16px !important;
}

.SmartGoals-module__font-s-18___bV7rw {
  font-size: 18px !important;
}

.SmartGoals-module__font-s-20___iO1EV {
  font-size: 20px !important;
}

.SmartGoals-module__font-s-22___D0bLs {
  font-size: 22px !important;
}

.SmartGoals-module__font-s-28___aRKXg {
  font-size: 28px !important;
}

.SmartGoals-module__font-w-400___Gob0l {
  font-weight: 400 !important;
}

.SmartGoals-module__font-w-500___nY4WK {
  font-weight: 500 !important;
}

.SmartGoals-module__font-w-600___OuHU6 {
  font-weight: 600 !important;
}

.SmartGoals-module__font-w-700___e_8l0 {
  font-weight: 700 !important;
}

.SmartGoals-module__p-5___Tnw57 {
  padding: 5px !important;
}

.SmartGoals-module__p-12___a4CwE {
  padding: 12px !important;
}

.SmartGoals-module__p-16___HzUYH {
  padding: 16px !important;
}

.SmartGoals-module__p-30___MPMmk {
  padding: 30px !important;
}

.SmartGoals-module__p-b-0___aQ2G8 {
  padding-bottom: 0 !important;
}

.SmartGoals-module__p-b-5___mwCDz {
  padding-bottom: 5px !important;
}

.SmartGoals-module__p-b-10___l3xJL {
  padding-bottom: 10px !important;
}

.SmartGoals-module__p-b-12___l50CC {
  padding-bottom: 12px !important;
}

.SmartGoals-module__p-b-16___HjyiH {
  padding-bottom: 16px !important;
}

.SmartGoals-module__p-b-18___E3Hmb {
  padding-bottom: 18px !important;
}

.SmartGoals-module__p-b-20___I9tYd {
  padding-bottom: 20px !important;
}

.SmartGoals-module__p-b-25___uoLpC {
  padding-bottom: 25px !important;
}

.SmartGoals-module__p-b-30___Ls4RI {
  padding-bottom: 30px !important;
}

.SmartGoals-module__p-b-50___uOSCI {
  padding-bottom: 50px !important;
}

.SmartGoals-module__p-t-0___ojziu {
  padding-top: 0 !important;
}

.SmartGoals-module__p-t-12___jTMIQ {
  padding-top: 12px !important;
}

.SmartGoals-module__p-t-16___tpqWA {
  padding-top: 16px !important;
}

.SmartGoals-module__p-t-18___S0lI2 {
  padding-top: 18px !important;
}

.SmartGoals-module__p-t-20___DIEb4 {
  padding-top: 20px !important;
}

.SmartGoals-module__p-t-30___lH_Zf {
  padding-top: 30px !important;
}

.SmartGoals-module__p-t-40___xxbEP {
  padding-top: 40px !important;
}

.SmartGoals-module__p-t-50___iyp8k {
  padding-top: 50px !important;
}

.SmartGoals-module__p-l-20___xQ5TQ {
  padding-left: 20px !important;
}

.SmartGoals-module__p-l-30___Ags4V {
  padding-left: 30px !important;
}

.SmartGoals-module__p-l-40___L26cI {
  padding-left: 40px !important;
}

.SmartGoals-module__p-r-16___xT_TW {
  padding-right: 16px !important;
}

.SmartGoals-module__p-r-20___zswdn {
  padding-right: 20px !important;
}

.SmartGoals-module__p-r-30___fwyut {
  padding-right: 30px !important;
}

.SmartGoals-module__p-r-50___z6DXh {
  padding-right: 50px !important;
}

.SmartGoals-module__p-r-60___KWfZi {
  padding-right: 60px !important;
}

.SmartGoals-module__m-b-1___Ezamw {
  margin-bottom: 1px !important;
}

.SmartGoals-module__m-b-2___toRfk {
  margin-bottom: 2px !important;
}

.SmartGoals-module__m-b-6____VHRp {
  margin-bottom: 6px !important;
}

.SmartGoals-module__m-b-8___ve0mm {
  margin-bottom: 8px !important;
}

.SmartGoals-module__m-b-10___dK9XG {
  margin-bottom: 10px !important;
}

.SmartGoals-module__m-b-14___Snqcg {
  margin-bottom: 14px !important;
}

.SmartGoals-module__m-b-16___l8dLD {
  margin-bottom: 16px !important;
}

.SmartGoals-module__m-b-20___gFDJO {
  margin-bottom: 20px !important;
}

.SmartGoals-module__m-b-22___nCpQj {
  margin-bottom: 22px !important;
}

.SmartGoals-module__m-b-24___b5Hd6 {
  margin-bottom: 24px !important;
}

.SmartGoals-module__m-b-30___reH1r {
  margin-bottom: 30px !important;
}

.SmartGoals-module__m-b-32___eRYIr {
  margin-bottom: 32px !important;
}

.SmartGoals-module__m-b-40___lj2X0 {
  margin-bottom: 40px !important;
}

.SmartGoals-module__m-t-2___eFimm {
  margin-top: 2px !important;
}

.SmartGoals-module__m-t-3___HRcbw {
  margin-top: 3px !important;
}

.SmartGoals-module__m-t-4___CyKoy {
  margin-top: 4px !important;
}

.SmartGoals-module__m-t-5___LKzae {
  margin-top: 5px !important;
}

.SmartGoals-module__m-t-8___XwUkw {
  margin-top: 8px !important;
}

.SmartGoals-module__m-t-10___Mmg_1 {
  margin-top: 10px !important;
}

.SmartGoals-module__m-t-15___h2VjP {
  margin-top: 15px !important;
}

.SmartGoals-module__m-t-16___f1leJ {
  margin-top: 16px !important;
}

.SmartGoals-module__m-t-20___zzkHa {
  margin-top: 20px !important;
}

.SmartGoals-module__m-t-22___hP1f4 {
  margin-top: 22px !important;
}

.SmartGoals-module__m-t-30___IzX8A {
  margin-top: 30px !important;
}

.SmartGoals-module__m-t-32___fkHTf {
  margin-top: 32px !important;
}

.SmartGoals-module__m-l-auto___XRbmd {
  margin-left: auto !important;
}

.SmartGoals-module__m-l-4___DL6OL {
  margin-left: 4px !important;
}

.SmartGoals-module__m-l-5___JMb2H {
  margin-left: 5px !important;
}

.SmartGoals-module__m-l-6___hZF15 {
  margin-left: 6px !important;
}

.SmartGoals-module__m-l-8___meNBc {
  margin-left: 8px !important;
}

.SmartGoals-module__m-l-10___Xnprs {
  margin-left: 10px !important;
}

.SmartGoals-module__m-l-16___pSVQo {
  margin-left: 16px !important;
}

.SmartGoals-module__m-l-20___nFYBQ {
  margin-left: 20px !important;
}

.SmartGoals-module__m-l-24___bPTTc {
  margin-left: 24px !important;
}

.SmartGoals-module__m-l-30___aXUYf {
  margin-left: 30px !important;
}

.SmartGoals-module__m-l-35___UOppB {
  margin-left: 35px !important;
}

.SmartGoals-module__m-l-40___OuP6f {
  margin-left: 40px !important;
}

.SmartGoals-module__m-r-8___Mf_Nj {
  margin-right: 8px !important;
}

.SmartGoals-module__m-r-10___uqzdo {
  margin-right: 10px !important;
}

.SmartGoals-module__m-r-16___U0RAr {
  margin-right: 16px !important;
}

.SmartGoals-module__m-r-20___iKbzJ {
  margin-right: 20px !important;
}

.SmartGoals-module__m-r-24___ygLQr {
  margin-right: 24px !important;
}

.SmartGoals-module__m-r-30___e9dOj {
  margin-right: 30px !important;
}

.SmartGoals-module__m-r-40___Aj3Eg {
  margin-right: 40px !important;
}

.SmartGoals-module__border-r-3___sCFHw {
  border-radius: 3px !important;
}

.SmartGoals-module__border-r-4___lYRqa {
  border-radius: 4px !important;
}

.SmartGoals-module__border-r-6___VlWhi {
  border-radius: 6px !important;
}

.SmartGoals-module__border-r-10___V2BiD {
  border-radius: 10px !important;
}

.SmartGoals-module__border-r-12___AT748 {
  border-radius: 12px !important;
}

.SmartGoals-module__border-r-16____dXIh {
  border-radius: 16px !important;
}

.SmartGoals-module__border-r-50___tb6gv {
  border-radius: 50% !important;
}

.SmartGoals-module__primary-border___Qnnav {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SmartGoals-module__primary-border-b___rIfvX {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SmartGoals-module__primary-border-t___qrahD {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SmartGoals-module__primary-border-l___aZ6DU {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SmartGoals-module__primary-border-r___Iq6i4 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SmartGoals-module__secondary-border___s_Udr {
  border: 1px solid #637768;
}

.SmartGoals-module__secondary-border-b___hQqeH {
  border-bottom: 1px solid #637768;
}

.SmartGoals-module__secondary-border-t___SKaTk {
  border-top: 1px solid #637768;
}

.SmartGoals-module__secondary-border-l___ArxhK {
  border-left: 1px solid #637768;
}

.SmartGoals-module__secondary-border-r___RUoOk {
  border-right: 1px solid #637768;
}

.SmartGoals-module__gap-0____Px0O {
  gap: 0 !important;
}

.SmartGoals-module__gap-2___czyV0 {
  gap: 2px !important;
}

.SmartGoals-module__gap-4___fAvKH {
  gap: 4px !important;
}

.SmartGoals-module__gap-5___yndz4 {
  gap: 5px !important;
}

.SmartGoals-module__gap-6___iHgfF {
  gap: 6px !important;
}

.SmartGoals-module__gap-8___nxUsJ {
  gap: 8px !important;
}

.SmartGoals-module__gap-10___WgmbR {
  gap: 10px !important;
}

.SmartGoals-module__gap-12___mTUUr {
  gap: 12px !important;
}

.SmartGoals-module__gap-14___LUdHY {
  gap: 14px !important;
}

.SmartGoals-module__gap-16___PBtZt {
  gap: 16px !important;
}

.SmartGoals-module__gap-18___Ysds8 {
  gap: 18px !important;
}

.SmartGoals-module__gap-20___F198F {
  gap: 20px !important;
}

.SmartGoals-module__gap-24___jgdLE {
  gap: 24px !important;
}

.SmartGoals-module__gap-26___sLxOp {
  gap: 26px !important;
}

.SmartGoals-module__gap-30___BEG0H {
  gap: 30px !important;
}

.SmartGoals-module__gap-32___PmZuh {
  gap: 32px !important;
}

.SmartGoals-module__gap-40___LWqJg {
  gap: 40px !important;
}

.SmartGoals-module__gap-50___pvMgk {
  gap: 50px !important;
}

.SmartGoals-module__flex-1___3gOMc {
  flex: 1;
}

.SmartGoals-module__flex-none___nm4pg {
  flex: none !important;
}

.SmartGoals-module__flex-column___uGRo_ {
  display: flex;
  flex-direction: column !important;
}

.SmartGoals-module__flex-row___ikDTp {
  display: flex;
  flex-direction: row !important;
}

.SmartGoals-module__vertically-centered___osZvZ {
  display: flex;
  align-items: center !important;
}

.SmartGoals-module__horizontally-centered___h9fvb {
  display: flex;
  justify-content: center !important;
}

.SmartGoals-module__horizontally-end___eo3_O {
  display: flex;
  justify-content: end !important;
}

.SmartGoals-module__vertically-start___hNht2 {
  display: flex;
  align-items: start !important;
}

.SmartGoals-module__space-between___zTZm0 {
  display: flex;
  justify-content: space-between !important;
}

.SmartGoals-module__flex-wrap___PjNV0 {
  flex-wrap: wrap !important;
}

.SmartGoals-module__height-100___Zl02K {
  height: 100%;
}

.SmartGoals-module__width-50___jhr0B {
  width: 50% !important;
}

.SmartGoals-module__width-100___Ghr1Q {
  width: 100%;
}

.SmartGoals-module__cursor-pointer___Sqdnp {
  cursor: pointer;
}

.SmartGoals-module__cursor-not-allowed___vN1oj {
  cursor: not-allowed !important;
}

.SmartGoals-module__absolute-centered___JDRbW {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SmartGoals-module__absolute___PRyS3 {
  position: absolute;
}

.SmartGoals-module__relative___dfInl {
  position: relative;
}

.SmartGoals-module__fixed___Lalto {
  position: fixed;
}

.SmartGoals-module__visible___H03WR {
  opacity: 1;
}

.SmartGoals-module__invisible___rCn5n {
  opacity: 0;
}

.SmartGoals-module__col-90___rKvEb {
  width: 90% !important;
}

.SmartGoals-module__col-auto___XouwZ {
  width: auto !important;
}

.SmartGoals-module__medical-tabs___V4mlG {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SmartGoals-module__medical-table-new___TI804 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SmartGoals-module__medical-table-new___TI804:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SmartGoals-module__medical-table-new___TI804::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SmartGoals-module__medical-table-new___TI804::-webkit-scrollbar-track {
  display: none;
}
.SmartGoals-module__medical-table-new___TI804.SmartGoals-module__no-pagination___OyCpv {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SmartGoals-module__medical-table-new___TI804.SmartGoals-module__no-pagination___OyCpv:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SmartGoals-module__medical-table-new___TI804.SmartGoals-module__no-pagination___OyCpv::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SmartGoals-module__medical-table-new___TI804.SmartGoals-module__no-pagination___OyCpv::-webkit-scrollbar-track {
  display: none;
}

.SmartGoals-module__medical-table-empty___hhv_h {
  padding: 14px 40px !important;
}

.SmartGoals-module__icon-btn___mXNFA {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SmartGoals-module__search-icon___nX8bD {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SmartGoals-module__disable-select___o94Ip {
  user-select: none;
}

.SmartGoals-module__break-word___NkmF4 {
  word-break: break-word;
}

.SmartGoals-module__popup-clear-btn___Axhao {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SmartGoals-module__scroll-m-b-20___OFl5c {
  scroll-margin-bottom: 20px;
}

.SmartGoals-module__button___Hp5o9 {
  height: 38px;
  margin: 25px 30px 0 auto;
}

.SmartGoals-module__scroll___EQO0C {
  height: calc(100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SmartGoals-module__scroll___EQO0C:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SmartGoals-module__scroll___EQO0C::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SmartGoals-module__scroll___EQO0C::-webkit-scrollbar-track {
  display: none;
}
.SmartGoals-module__scroll___EQO0C .SmartGoals-module__tabs___t36Mk {
  padding: 0;
  margin: 20px 40px -6px 40px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/SmartGoals/SmartGoals.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,YAAA;EACA,wBAAA;AA8pBF;;AA3pBA;ECGE,2GDDE;ECEF,kBAAA;EACA,kBAAA;AD4pBF;AC1pBE;EACE,oCAAA;EACA,mBAAA;AD4pBJ;ACzpBE;EACE,UAAA;EACA,6BAAA;AD2pBJ;ACxpBE;EACE,aAAA;AD0pBJ;AArqBE;EACE,UAAA;EACA,2BAAA;AAuqBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.button {\n  height: 38px;\n  margin: 25px 30px 0 auto;\n}\n\n.scroll {\n  @include verticalScroll(\n    calc(\n      100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer)\n    )\n  );\n\n  .tabs {\n    padding: 0;\n    margin: 20px 40px -6px 40px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SmartGoals-module__font-s-10___apIa3`,
	"fontS12": `SmartGoals-module__font-s-12___oQYFc`,
	"fontS13": `SmartGoals-module__font-s-13___gV4ah`,
	"fontS14": `SmartGoals-module__font-s-14___gHUbm`,
	"fontS15": `SmartGoals-module__font-s-15___qD8NW`,
	"fontS16": `SmartGoals-module__font-s-16___k4uhq`,
	"fontS18": `SmartGoals-module__font-s-18___bV7rw`,
	"fontS20": `SmartGoals-module__font-s-20___iO1EV`,
	"fontS22": `SmartGoals-module__font-s-22___D0bLs`,
	"fontS28": `SmartGoals-module__font-s-28___aRKXg`,
	"fontW400": `SmartGoals-module__font-w-400___Gob0l`,
	"fontW500": `SmartGoals-module__font-w-500___nY4WK`,
	"fontW600": `SmartGoals-module__font-w-600___OuHU6`,
	"fontW700": `SmartGoals-module__font-w-700___e_8l0`,
	"p5": `SmartGoals-module__p-5___Tnw57`,
	"p12": `SmartGoals-module__p-12___a4CwE`,
	"p16": `SmartGoals-module__p-16___HzUYH`,
	"p30": `SmartGoals-module__p-30___MPMmk`,
	"pB0": `SmartGoals-module__p-b-0___aQ2G8`,
	"pB5": `SmartGoals-module__p-b-5___mwCDz`,
	"pB10": `SmartGoals-module__p-b-10___l3xJL`,
	"pB12": `SmartGoals-module__p-b-12___l50CC`,
	"pB16": `SmartGoals-module__p-b-16___HjyiH`,
	"pB18": `SmartGoals-module__p-b-18___E3Hmb`,
	"pB20": `SmartGoals-module__p-b-20___I9tYd`,
	"pB25": `SmartGoals-module__p-b-25___uoLpC`,
	"pB30": `SmartGoals-module__p-b-30___Ls4RI`,
	"pB50": `SmartGoals-module__p-b-50___uOSCI`,
	"pT0": `SmartGoals-module__p-t-0___ojziu`,
	"pT12": `SmartGoals-module__p-t-12___jTMIQ`,
	"pT16": `SmartGoals-module__p-t-16___tpqWA`,
	"pT18": `SmartGoals-module__p-t-18___S0lI2`,
	"pT20": `SmartGoals-module__p-t-20___DIEb4`,
	"pT30": `SmartGoals-module__p-t-30___lH_Zf`,
	"pT40": `SmartGoals-module__p-t-40___xxbEP`,
	"pT50": `SmartGoals-module__p-t-50___iyp8k`,
	"pL20": `SmartGoals-module__p-l-20___xQ5TQ`,
	"pL30": `SmartGoals-module__p-l-30___Ags4V`,
	"pL40": `SmartGoals-module__p-l-40___L26cI`,
	"pR16": `SmartGoals-module__p-r-16___xT_TW`,
	"pR20": `SmartGoals-module__p-r-20___zswdn`,
	"pR30": `SmartGoals-module__p-r-30___fwyut`,
	"pR50": `SmartGoals-module__p-r-50___z6DXh`,
	"pR60": `SmartGoals-module__p-r-60___KWfZi`,
	"mB1": `SmartGoals-module__m-b-1___Ezamw`,
	"mB2": `SmartGoals-module__m-b-2___toRfk`,
	"mB6": `SmartGoals-module__m-b-6____VHRp`,
	"mB8": `SmartGoals-module__m-b-8___ve0mm`,
	"mB10": `SmartGoals-module__m-b-10___dK9XG`,
	"mB14": `SmartGoals-module__m-b-14___Snqcg`,
	"mB16": `SmartGoals-module__m-b-16___l8dLD`,
	"mB20": `SmartGoals-module__m-b-20___gFDJO`,
	"mB22": `SmartGoals-module__m-b-22___nCpQj`,
	"mB24": `SmartGoals-module__m-b-24___b5Hd6`,
	"mB30": `SmartGoals-module__m-b-30___reH1r`,
	"mB32": `SmartGoals-module__m-b-32___eRYIr`,
	"mB40": `SmartGoals-module__m-b-40___lj2X0`,
	"mT2": `SmartGoals-module__m-t-2___eFimm`,
	"mT3": `SmartGoals-module__m-t-3___HRcbw`,
	"mT4": `SmartGoals-module__m-t-4___CyKoy`,
	"mT5": `SmartGoals-module__m-t-5___LKzae`,
	"mT8": `SmartGoals-module__m-t-8___XwUkw`,
	"mT10": `SmartGoals-module__m-t-10___Mmg_1`,
	"mT15": `SmartGoals-module__m-t-15___h2VjP`,
	"mT16": `SmartGoals-module__m-t-16___f1leJ`,
	"mT20": `SmartGoals-module__m-t-20___zzkHa`,
	"mT22": `SmartGoals-module__m-t-22___hP1f4`,
	"mT30": `SmartGoals-module__m-t-30___IzX8A`,
	"mT32": `SmartGoals-module__m-t-32___fkHTf`,
	"mLAuto": `SmartGoals-module__m-l-auto___XRbmd`,
	"mL4": `SmartGoals-module__m-l-4___DL6OL`,
	"mL5": `SmartGoals-module__m-l-5___JMb2H`,
	"mL6": `SmartGoals-module__m-l-6___hZF15`,
	"mL8": `SmartGoals-module__m-l-8___meNBc`,
	"mL10": `SmartGoals-module__m-l-10___Xnprs`,
	"mL16": `SmartGoals-module__m-l-16___pSVQo`,
	"mL20": `SmartGoals-module__m-l-20___nFYBQ`,
	"mL24": `SmartGoals-module__m-l-24___bPTTc`,
	"mL30": `SmartGoals-module__m-l-30___aXUYf`,
	"mL35": `SmartGoals-module__m-l-35___UOppB`,
	"mL40": `SmartGoals-module__m-l-40___OuP6f`,
	"mR8": `SmartGoals-module__m-r-8___Mf_Nj`,
	"mR10": `SmartGoals-module__m-r-10___uqzdo`,
	"mR16": `SmartGoals-module__m-r-16___U0RAr`,
	"mR20": `SmartGoals-module__m-r-20___iKbzJ`,
	"mR24": `SmartGoals-module__m-r-24___ygLQr`,
	"mR30": `SmartGoals-module__m-r-30___e9dOj`,
	"mR40": `SmartGoals-module__m-r-40___Aj3Eg`,
	"borderR3": `SmartGoals-module__border-r-3___sCFHw`,
	"borderR4": `SmartGoals-module__border-r-4___lYRqa`,
	"borderR6": `SmartGoals-module__border-r-6___VlWhi`,
	"borderR10": `SmartGoals-module__border-r-10___V2BiD`,
	"borderR12": `SmartGoals-module__border-r-12___AT748`,
	"borderR16": `SmartGoals-module__border-r-16____dXIh`,
	"borderR50": `SmartGoals-module__border-r-50___tb6gv`,
	"primaryBorder": `SmartGoals-module__primary-border___Qnnav`,
	"primaryBorderB": `SmartGoals-module__primary-border-b___rIfvX`,
	"primaryBorderT": `SmartGoals-module__primary-border-t___qrahD`,
	"primaryBorderL": `SmartGoals-module__primary-border-l___aZ6DU`,
	"primaryBorderR": `SmartGoals-module__primary-border-r___Iq6i4`,
	"secondaryBorder": `SmartGoals-module__secondary-border___s_Udr`,
	"secondaryBorderB": `SmartGoals-module__secondary-border-b___hQqeH`,
	"secondaryBorderT": `SmartGoals-module__secondary-border-t___SKaTk`,
	"secondaryBorderL": `SmartGoals-module__secondary-border-l___ArxhK`,
	"secondaryBorderR": `SmartGoals-module__secondary-border-r___RUoOk`,
	"gap0": `SmartGoals-module__gap-0____Px0O`,
	"gap2": `SmartGoals-module__gap-2___czyV0`,
	"gap4": `SmartGoals-module__gap-4___fAvKH`,
	"gap5": `SmartGoals-module__gap-5___yndz4`,
	"gap6": `SmartGoals-module__gap-6___iHgfF`,
	"gap8": `SmartGoals-module__gap-8___nxUsJ`,
	"gap10": `SmartGoals-module__gap-10___WgmbR`,
	"gap12": `SmartGoals-module__gap-12___mTUUr`,
	"gap14": `SmartGoals-module__gap-14___LUdHY`,
	"gap16": `SmartGoals-module__gap-16___PBtZt`,
	"gap18": `SmartGoals-module__gap-18___Ysds8`,
	"gap20": `SmartGoals-module__gap-20___F198F`,
	"gap24": `SmartGoals-module__gap-24___jgdLE`,
	"gap26": `SmartGoals-module__gap-26___sLxOp`,
	"gap30": `SmartGoals-module__gap-30___BEG0H`,
	"gap32": `SmartGoals-module__gap-32___PmZuh`,
	"gap40": `SmartGoals-module__gap-40___LWqJg`,
	"gap50": `SmartGoals-module__gap-50___pvMgk`,
	"flex1": `SmartGoals-module__flex-1___3gOMc`,
	"flexNone": `SmartGoals-module__flex-none___nm4pg`,
	"flexColumn": `SmartGoals-module__flex-column___uGRo_`,
	"flexRow": `SmartGoals-module__flex-row___ikDTp`,
	"verticallyCentered": `SmartGoals-module__vertically-centered___osZvZ`,
	"horizontallyCentered": `SmartGoals-module__horizontally-centered___h9fvb`,
	"horizontallyEnd": `SmartGoals-module__horizontally-end___eo3_O`,
	"verticallyStart": `SmartGoals-module__vertically-start___hNht2`,
	"spaceBetween": `SmartGoals-module__space-between___zTZm0`,
	"flexWrap": `SmartGoals-module__flex-wrap___PjNV0`,
	"height100": `SmartGoals-module__height-100___Zl02K`,
	"width50": `SmartGoals-module__width-50___jhr0B`,
	"width100": `SmartGoals-module__width-100___Ghr1Q`,
	"cursorPointer": `SmartGoals-module__cursor-pointer___Sqdnp`,
	"cursorNotAllowed": `SmartGoals-module__cursor-not-allowed___vN1oj`,
	"absoluteCentered": `SmartGoals-module__absolute-centered___JDRbW`,
	"absolute": `SmartGoals-module__absolute___PRyS3`,
	"relative": `SmartGoals-module__relative___dfInl`,
	"fixed": `SmartGoals-module__fixed___Lalto`,
	"visible": `SmartGoals-module__visible___H03WR`,
	"invisible": `SmartGoals-module__invisible___rCn5n`,
	"col90": `SmartGoals-module__col-90___rKvEb`,
	"colAuto": `SmartGoals-module__col-auto___XouwZ`,
	"medicalTabs": `SmartGoals-module__medical-tabs___V4mlG`,
	"medicalTableNew": `SmartGoals-module__medical-table-new___TI804`,
	"noPagination": `SmartGoals-module__no-pagination___OyCpv`,
	"medicalTableEmpty": `SmartGoals-module__medical-table-empty___hhv_h`,
	"iconBtn": `SmartGoals-module__icon-btn___mXNFA`,
	"searchIcon": `SmartGoals-module__search-icon___nX8bD`,
	"disableSelect": `SmartGoals-module__disable-select___o94Ip`,
	"breakWord": `SmartGoals-module__break-word___NkmF4`,
	"popupClearBtn": `SmartGoals-module__popup-clear-btn___Axhao`,
	"scrollMB20": `SmartGoals-module__scroll-m-b-20___OFl5c`,
	"button": `SmartGoals-module__button___Hp5o9`,
	"scroll": `SmartGoals-module__scroll___EQO0C`,
	"tabs": `SmartGoals-module__tabs___t36Mk`
};
module.exports = ___CSS_LOADER_EXPORT___;
